export const IdXboxIntroFormId = "id-xbox-intro";
export const gameConceptBigIdLength = 12;

export enum IdXboxIntroSubFormsId {
  ContactInformation = "contact",
  StudioInformation = "studio",
}

export const IdXboxIntroSubFormsIdsOrder = [
  IdXboxIntroSubFormsId.ContactInformation,
  IdXboxIntroSubFormsId.StudioInformation,
];

export const IdXboxIntroSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "introFormsTitle",
  ["formSubtitle"]: "",
  [IdXboxIntroSubFormsId.ContactInformation]: "introContactInformationTitle",
  [IdXboxIntroSubFormsId.StudioInformation]: "introStudioInformationTitle",
};
